// extracted by mini-css-extract-plugin
export default {"ImageWithText":"ImageWithText_ImageWithText__7j32y","ImageWithText__container":"ImageWithText_ImageWithText__container__p03eJ"};